<template>
  <div>
    <v-row>
      <v-col>
        <v-row v-if="type === 'partners'">
          <v-spacer></v-spacer>
          <v-col class="text-right mr-5">
            <DialogCreateNewMember :type="type" @getMembers="getMembers()" />
          </v-col>
        </v-row>
        <v-data-table
          :loading="$store.state.members.loading"
          :headers="headers"
          :items="$store.state.members[type]"
        >
          <template v-slot:item.action="{ item }">
            <DialogMember :propMember="item" :type="type" />
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DialogMember from '@/components/DialogMember';
import DialogCreateNewMember from '@/components/DialogCreateNewMember';

export default {
  name: 'Members',

  components: {
    DialogMember,
    DialogCreateNewMember
  },

  data: () => ({
    headers: [
      { text: 'User ID', value: 'username' },
      { text: 'Status', value: 'userStatus' },
      { text: 'Modified', value: 'userLastModifiedDate' },
      { text: 'Created', value: 'userCreateDate' },
      { text: 'Email', value: 'email' },
      { text: 'Email Verified', value: 'emailVerified' },
      { text: 'Phone', value: 'phoneNumber' },
      { text: 'Phone Verified', value: 'phoneNumberVerified' },
      { text: 'Enabled', value: 'enabled' },
      { text: 'Actions', value: 'action', sortable: false }
    ]
  }),

  props: {
    type: {
      type: String,
      required: true
    }
  },

  mounted() {
    this.getMembers();
    this.getTenants();
  },

  methods: {
    getMembers() {
      this.$store.dispatch('members/getByType', this.type);
    },
    getTenants() {
      this.$store.dispatch('tenants/getTenantsList');
    }
  }
};
</script>
